import { useSelector } from 'react-redux';
import makeSelectPrivileges from 'store/privileges/selectors';
import { Privileges } from 'types/privileges';

export default function usePrivileges(): Privileges {
  return useSelector((state) => makeSelectPrivileges()(state).features);
}
